import { render, staticRenderFns } from "./BusinessProcessPage.vue?vue&type=template&id=32d47f85&"
import script from "./BusinessProcessPage.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcessPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports